import React from 'react';

const RecentBlogsHeading: React.FC = () => (
	<div>
		<h2>My latest blogs</h2>
	</div>
);

export default RecentBlogsHeading;
